"use client";

import type { useBuyBoxFactory } from "@trydig/centra/client";
import { useTranslations } from "@/i18n/client";

export const useBuyBoxLabels = (): Parameters<
	typeof useBuyBoxFactory
>[0]["labels"] => {
	const t = useTranslations();

	return {
		add_to_cart: t("Add to cart"),
		coming_soon: t("Coming soon"),
		out_of_stock: t("Coming soon"),
		select_size: t("Select size"),
		preorder: t("Pre-order"),
		stock_outside_default_allocation_rule: t("Coming soon"),
	};
};
